import { render, staticRenderFns } from "./registration-requests.page.vue?vue&type=template&id=7647c1aa&scoped=true&"
import script from "./registration-requests.page.vue?vue&type=script&lang=js&"
export * from "./registration-requests.page.vue?vue&type=script&lang=js&"
import style0 from "./registration-requests.page.vue?vue&type=style&index=0&id=7647c1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7647c1aa",
  null
  
)

export default component.exports